// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"553":"24c89c52","977":"2aeecb60"}[chunkId] + ".chunk.js");